import drFormio from './dr-formio.vue'

const schema = {
  allowInToolbox: true,
  $Type: 'dr-formio',
  name: 'Formio',
  group: 'Advanced',
  icon: 'th-large',
  properties: {
    $ID: {
      name: 'vuetifyWidgets.dr-base.id',
      type: 'string'
    },
    Class: {
      name: 'vuetifyWidgets.dr-base.cssClass',
      type: 'string'
    },
    FormCode: {
      name: 'vuetifyWidgets.dr-formio.formCode',
      type: 'any',
      component: 'dr-formio-forms'
    },
    OnCustomEvent: {
      name: 'vuetifyWidgets.dr-formio.actionBeforeCustomEvent',
      type: 'string',
      default: 'text',
      enum: [{
        value: 'dataSourceAction',
        text: 'Data Source Action'
      }]
    },
    OnCustomEventCallback: {
      name: 'vuetifyWidgets.dr-formio.actionAfterCustomEvent',
      type: 'string',
      default: 'text',
      enum: [{
        value: 'dataSourceAction',
        text: 'Data Source Action'
      }]
    },
    FormioParams: {
      name: 'vuetifyWidgets.dr-formio.formioParams',
      type: 'any',
      component: 'dr-object-editor'
    }
  }
}

export default {
  schema,
  component: drFormio,
  propEditors: [
    {
      name: 'dr-formio-forms'
    }
  ]
}
